import styled, { css } from "styled-components"
import { Link } from "gatsby"

export const ExampleArrow = styled.span`
  display: inline-block;
  font-family: "klipfolio-icons";
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  font-size: 0.8em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  vertical-align: middle;
  color: white;
  transition: transform linear 0.2s;
  &:after {
    content: "R";
  }
`

export const ExampleGridItem = styled.div`
  height: 100%;
  display: flex;
  box-shadow: 0 1px 2px rgb(0 0 0 / 10%), 0 5px 15px rgb(0 0 0 / 5%),
    0 0px 15px rgb(0 0 0 / 5%);
  flex-direction: column;
  background: #fff;
  transition: box-shadow 0.3s ease;
  border-radius: 0.5rem;
  &:hover {
    box-shadow: 0 1px 2px rgb(0 0 0 / 10%), 0px 0px 2px rgb(0 0 0 / 5%),
      0 0px 2px rgb(0 0 0 / 5%);
  }
`

export const ExampleHoverBackground = styled.div`
  display: flex;
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 100%;
  opacity: 0;
  background: #21264f;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  transition: opacity 0.35s ease-in-out;
  border-radius: ${props => (props.radius ? props.radius : "")};
  :hover {
    opacity: 85%;
  }
`

export const ExampleScreenshot = styled.div`
  position: relative;
  object-fit: cover;
  overflow: hidden;

  svg {
    max-height: 100%;
    margin: 0 auto;
  }

  justify-content: center;

  ${props =>
    props.kpi &&
    css`
      position: relative;
      display: flex;
      align-items: center;
      object-fit: cover;
      height: ${props => props.height ?? "16rem"};
      padding: 2rem;
      .klipfolio-image-wrapper div {
        box-shadow: ${props =>
          props.shadow &&
          `0 15px 20px rgb(32 51 70 / 30%), 0 0px 30px rgb(32 51 70 / 20%)`};
        border-radius: 0.5rem;
        img {
          max-height: 12rem;
          width: auto;
          object-fit: contain;
        }
      }
    `}
  ${props =>
    !props.kpi &&
    css`
      border-radius: 1rem;
      margin-bottom: 1rem;
      z-index: 1;
      box-shadow: 0px 64px 64px 0px rgb(160 180 200 / 40%),
        0px 32px 32px 0px rgb(160 180 200 / 60%),
        0px 8px 8px 0px rgb(160 180 200 / 80%), 0px 2px 2px 0px #a0b4c8;
      transition: box-shadow 0.5s ease;
      &:hover {
        box-shadow: 0px 32px 32px 0px rgb(160 180 200 / 60%),
          0px 8px 8px 0px rgb(160 180 200 / 80%), 0px 2px 2px 0px #a0b4c8;
      }
    `}
`

export const ExampleScreenshotWrapper = styled(Link)`
  background: #f3f5fc !important;
  border-bottom: 1px solid #ddd;
`
